import React from 'react';

import Icon from 'Core/Components/Icon';
import Fieldset from 'RLX/Forms/Fieldset';
import OrderingControls from 'Core/Components/OrderingControls';

class ListFieldItem extends React.Component {
  constructor (props) {
    super(props);
    this.state = { isPreviewing: false };
    this.handleMove = this.handleMove.bind(this);
    this.handleUpdate = this.handleUpdate.bind(this);
    this.togglePreview = this.togglePreview.bind(this);
    this.propertyUpdaterFactory = this.propertyUpdaterFactory.bind(this);
    this.isDeletable = true;
  }

  handleUpdate (value) {
    const { onChange } = this.props;
    if (typeof onChange !== 'function') return;
    onChange(value);
  }

  togglePreview () {
    const { isPreviewing } = this.state;
    this.setState({ isPreviewing: !isPreviewing });
  }

  renderPreview () {
    return null;
  }

  propertyUpdaterFactory (propertyName, currentValue) {
    const { handleUpdate } = this;
    return (newValue) => handleUpdate({ ...currentValue, [propertyName]: newValue });
  }

  shouldRenderPreviewInline () {
    return false;
  }

  getItemTitle (index, count) {
    return `Item ${index + 1}${count ? ` of ${count}` : ''}`;
  }

  getFields () {
    return [];
  }

  getClassName () {
    return null;
  }

  handleMove (direction, disabled) {
    if (disabled) return;
    const { onReorder, index } = this.props;
    if (typeof onReorder !== 'function')
      throw new TypeError(`ListFieldItem.handleMove: onReorder is not a function (${onReorder})`);
    onReorder(index, direction);
  }

  render () {
    const { isPreviewing } = this.state;
    const { index, count, onDelete, horizontal, children } = this.props;
    const fields = this.getFields();
    const className = this.getClassName();
    const itemTitle = this.getItemTitle(index, count);
    const preview = this.renderPreview();
    const shouldRenderPreviewInline = this.shouldRenderPreviewInline();
    const deleteHandler = typeof onDelete === 'function' && this.isDeletable
      ? () => onDelete(index)
      : null;

    const itemCount = typeof index === 'number' ? index + 1 : null;
    const toggleProps = { onClick: this.togglePreview, className: 'ListField-Toggle' };
    return (
      <div className={'ListFieldItem' + (className ? ' ' + className : '')}>
        <legend style={{ width: '100%' }}>
          <div className="ListField-Ordering">
            <OrderingControls
              isFirst={!index}
              horizontal={horizontal}
              isLast={count === index + 1}
              handleMove={this.handleMove}
              controlWrapper={(content) => (
                <button className="slim positive">{content}</button>
              )}
            />
          </div>

          <span className="ListField-Title">{itemTitle}</span>

          {!preview || shouldRenderPreviewInline
            ? null
            : isPreviewing
              ? <a {...toggleProps}><Icon fa="paint-brush"/> Switch to Editor</a>
              : <a {...toggleProps}><Icon fa="eye"/> Switch to Preview</a>
          }
          <div style={{ float: 'right '}}>
            {!deleteHandler ? null : (
              <a
                onClick={deleteHandler}
                title="Delete This Item"
                className="ListField-Delete deleteLink">
                <Icon fa="times"/>
              </a>
            )}
          </div>
        </legend>
        {!preview || !isPreviewing || shouldRenderPreviewInline
          ? <Fieldset fields={fields} />
          : null
        }
        {!children ? null : children}
        {preview && isPreviewing
          ? preview
          : null
        }
      </div>
    )
  }
};

export default ListFieldItem;



// WEBPACK FOOTER //
// ./client/RLX/Forms/ListField/ListFieldItem.jsx